import MySpinner from 'components/MySpinner'
import React from 'react'
import { Button } from 'react-bootstrap'
import './Inputs.css'

interface ILoadingBlueButtonProp {
  href?: string
  onClick?: (event: React.MouseEvent<HTMLElement>) => void
  disabled?: boolean
  isLoading?: boolean
  style?: React.CSSProperties
  className?: string
  children?: any
}

const LoadingBlueButton: React.FC<ILoadingBlueButtonProp> = ({
  href,
  onClick,
  disabled,
  isLoading,
  className,
  style,
  children,
}) => {
  return (
    <Button
      type='button'
      className={'btn btn-blue btn-round ' + className}
      style={{
        display: 'flex',
        justifyContent: 'center',
        columnGap: '1rem',
        ...style,
      }}
      onClick={onClick}
      href={href}
      disabled={disabled || isLoading}
    >
      {isLoading && <MySpinner size='medium' />}
      {children}
    </Button>
  )
}
export default LoadingBlueButton
